export const SUBJECTS_ENDPOINTS = {
  BASE: "/v1/subjects",
  DETAIL: (id: string) => `/v1/subjects/${id}`,
  /** Ouverture aux élèves : état et nombre de cours (GET), interrupteur (PUT). */
  ACTIVATION: (id: string) => `/v1/subjects/${id}/activation`,
} as const;
